module.exports = __webpack_public_path__ + "ad.4baaafc5.png";